import { api, createCancelTokenHandler } from "../utils";

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  select: function (params: any = null) {
    return api.get(`${endPoint()}/api/select/sales-order`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.select.name].handleRequestCancellation()
          .token,
    });
  },
  findAll: function (params: any = null) {
    return api.get(`${endPoint()}/api/sales-order`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.findAll.name].handleRequestCancellation()
          .token,
    });
  },
  findOne: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/sales-order/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.findOne.name].handleRequestCancellation()
          .token,
    });
  },
  create: function (payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/sales-order`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.create.name].handleRequestCancellation()
          .token,
    });
  },
  update: function (id: number | string, payload: any, params: any = null) {
    return api.put(`${endPoint()}/api/sales-order/${id}`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.update.name].handleRequestCancellation()
          .token,
    });
  },
  delete: function (id: number | string, params: any = null) {
    return api.delete(`${endPoint()}/api/sales-order/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.delete.name].handleRequestCancellation()
          .token,
    });
  },
  detailCode: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/sales-order/${id}/detail-code`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.findOne.name].handleRequestCancellation()
          .token,
    });
  },
  updateValidDate: function (
    id: number | string,
    payload: any,
    params: any = null
  ) {
    return api.put(`${endPoint()}/api/sales-order/${id}/valid-date`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.update.name].handleRequestCancellation()
          .token,
    });
  },
  importDirect: function (payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/sales-order/import`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[
          this.importDirect.name
        ].handleRequestCancellation().token,
    });
  },
  importLoyalty: function (payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/sales-order/import-loyalty`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[
          this.importDirect.name
        ].handleRequestCancellation().token,
    });
  },
  export: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/sales-order/${id}/excel`, {
      params,
      responseType: "blob",
      cancelToken:
        cancelTokenHandlerObject[this.findOne.name].handleRequestCancellation()
          .token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);

export default Repository;
